import { combineReducers, createStore } from "redux";
import portfolioReducer from "./noteReducer";

const rootReducer = combineReducers({
    // notes:noteReducer
    port: portfolioReducer
})

// const noteStore = ()=>{
//     return createStore(rootReducer);
// }

export const noteStore = createStore(rootReducer);